import { render, staticRenderFns } from "./CustomerSupports.vue?vue&type=template&id=459ce66a&scoped=true"
import script from "./CustomerSupports.vue?vue&type=script&lang=js"
export * from "./CustomerSupports.vue?vue&type=script&lang=js"
import style0 from "./CustomerSupports.vue?vue&type=style&index=0&id=459ce66a&prod&scoped=true&lang=css"
import style1 from "./CustomerSupports.vue?vue&type=style&index=1&id=459ce66a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459ce66a",
  null
  
)

export default component.exports